import { lang } from '@umu/ukit-lang';
import { LabelAndValueOptions } from './interface';

export const aiSubtitlePositionOptions = [
    { label: lang('画面下方'), value: '1' },
    { label: lang('画面上方'), value: '2' },
];

export enum AiSubTitleCurrentOperation {
    all,
    language,
    fontSize,
}

export enum MoreSettingCurrentOperation {
    all,
    aiSubTitleTranslate,
}

export const aiSubTitleCurrentOperationTitleMap = {
    [AiSubTitleCurrentOperation.all]: '',
    [AiSubTitleCurrentOperation.language]: lang('字幕语言'),
    [AiSubTitleCurrentOperation.fontSize]: lang('字体大小'),
};

export const aiSubtitleFontSizeOptions: LabelAndValueOptions[] = [
    {
        label: lang('特小'),
        value: '1',
    },
    {
        label: lang('小'),
        value: '2',
    },
    {
        label: lang('正常'),
        value: '3',
        isSelected: true,
    },
    {
        label: lang('大_150%'),
        value: '4',
    },
    {
        label: lang('特大'),
        value: '5',
    },
];

export enum aiSubtitleTypeMap {
    origin = 1,
    translate = 2,
}
